<template>
  <tr class="template-row">
    <td class="template-col">
      <h4 @click="$emit('to-user', user.id)" class="template__name">{{ user.name }}</h4>
    </td>
    <td class="template-col bh-user-col--full">
      {{user.description}}
    </td>
    <td class="template-col">
      <span class="bhGray2--text text-nowrap">
        {{ user.creationDate | moment("MMMM Do, YYYY")}}
      </span>
    </td>
    <td class="template-col">
      <v-btn icon color="accent" elevation="0" @click="$emit('to-user', user.id)">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'TemplatesTableRow',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
  }
}
</script>

<style lang="scss">
.template {
  &__name {
    min-width: 300px;
    padding-left: 10px;
    max-width: 50%;
    margin-bottom: 4px;
    cursor: pointer;
  }

  &__avatar {
    overflow: hidden;
    border-radius: 8px;
    width: 48px;
    height: 54px;
    img {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  &-row {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: $border-radius-root;

    &:hover {
      background: transparent !important;
    }
  }

  &-col {
    padding: 8px !important;
    border-bottom: 0 !important;
    background: $bh-white;

    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      font-size: 0.857rem;
      line-height: 1rem;
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
      text-align: right;
    }

    .text-number {
      font-size: 1.125rem;
    }
  }
}
</style>
